import {Component, OnInit, ViewChild} from '@angular/core';
import {PageHeaderBarConfig, PageSubheaderBarConfig} from '../../../fw/pages/page-config-api';
import {BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {AutoUnsubscribe} from '../../../fw/decoractors/AutoUnsubscribe';
import {FormBuilder, FormGroup} from "@angular/forms";
import {DtoQuickview} from "./models/DtoQuickview";
import {ManagementQuickviewService} from "./management-quickview.service";
import {DtoBranchUser} from "../../shared/models/DtoBranchUser";
import {SharedService} from "../../shared/shared.service";
import {SharedDataService} from "../../shared/shared-data.service";
import {Border, ChartComponent} from "@progress/kendo-angular-charts";

@Component({
    selector: 'app-management-quickview',
    template: require('./management-quickview.component.html'),
    styles: [require('./management-quickview.component.css')]
})

@AutoUnsubscribe()
export class ManagementQuickviewComponent implements OnInit {
    @ViewChild('chartTreatments', {static: false}) chartTreatments: ChartComponent;
    filterHeaderConfig: PageHeaderBarConfig;
    pshbConfigTreatments: PageSubheaderBarConfig;
    pshbConfigArticles: PageSubheaderBarConfig;
    pshbConfigVisitors: PageSubheaderBarConfig;
    pshbConfigAverageSales: PageSubheaderBarConfig;
    quarters: Array<{ text: string, value: number }> = [
        { text: "1e kwartaal", value: 1 },
        { text: "2e kwartaal", value: 2 },
        { text: "3e kwartaal", value: 3 },
        { text: "4e kwartaal", value: 4 },
        { text: "Per maand", value: 5 }
    ];
    years: Array<{ text: string, value: number }> = [];
    branches: DtoBranchUser[];
    filterForm: FormGroup;
    data: DtoQuickview;
    legendBorder: Border = {
        color: '#bababa',
        dashType: "solid",
        width: 1
    };

    constructor(private breadcrumService: BreadcrumService,
                private fb: FormBuilder,
                private ds: ManagementQuickviewService,
                private ss: SharedService,
                private sds: SharedDataService) { }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'management', isLastStep: false },
            { text: 'quickview salon', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');
        this.filterHeaderConfig = {
            title: 'INSTELLINGEN',
            buttonDefinition: [
                {
                    description: 'RESULTATEN',
                    isSmall: false,
                    clickEventType: 'filter'
                }
            ]
        };
        this.pshbConfigTreatments = {
            title: 'OMZET BEHANDELINGEN INCL. BTW',
            buttonDefinition: []
        };
        this.pshbConfigArticles = {
            title: 'OMZET ARTIKELEN INCL. BTW',
            buttonDefinition: []
        };
        this.pshbConfigVisitors = {
            title: 'AANTAL BEZOEKEN',
            buttonDefinition: []
        };
        this.pshbConfigAverageSales = {
            title: 'GEMIDDELDE BESTEDING INCL. BTW',
            buttonDefinition: []
        };


        for (let i = 0; i < 5; i++) {
            this.years.push({
                text: (this.ss.getCurrentYear() - i).toString(),
                value: this.ss.getCurrentYear() - i
            });
        }

        this.filterForm = this.fb.group({
            year: this.ss.getCurrentYear(),
            quarter: this.ss.getCurrentQuarter(),
            userId: 0
        });

        this.sds.getBranchesWithAll().subscribe((res: DtoBranchUser[]) => {
            this.branches = res;
        });

        setTimeout(() => {
            this.chartTreatments.chartArea = {
                margin: 0
            };
            this.loadData();
        });

    }

    loadData() {
        this.ds.getQuickview({
            userId: this.filterForm.value.userId,
            year: this.filterForm.value.year,
            quarter: this.filterForm.value.quarter
        }).subscribe((res: DtoQuickview) => {
            this.data = res;
        });
    }

    phbBtnClicked(event) {
        if (event == 'filter') {
            this.loadData();
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/management/quickview/management-quickview.component.ts